// v3.4.557 — معاينة ملف Word بدقة التنسيق داخل المتصفح (docx-preview): الخطوط (Sakkal Majalla…)، تظليل الخلايا، عرض الأعمدة، الرأس والتذييل والشعار، أبعاد الصفحة
// بدل التحويل التقريبي إلى HTML (mammoth) الذي كان يُسقط تنسيق قالب وافي كله. يستقبل ArrayBuffer أو دالة تجلبه.
import React, { useEffect, useRef, useState } from "react";
import { renderAsync } from "docx-preview";

export default function DocxPreview({ source, deps = [], height = 900, zoom = 1, letterhead = false }) {
  const ref = useRef(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(true);
  const [pages, setPages] = useState(0);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      setBusy(true); setErr(""); setPages(0);
      try {
        const buf = typeof source === "function" ? await source() : source;
        if (cancelled || !ref.current) return;
        ref.current.innerHTML = "";
        await renderAsync(buf, ref.current, undefined, { className: "docx", inWrapper: true, ignoreWidth: false, ignoreHeight: false, ignoreFonts: false, breakPages: true, renderHeaders: letterhead, renderFooters: letterhead, renderFootnotes: true, useBase64URL: true, experimental: true }); // v3.4.558 — بلا ترويسة الشركة افتراضيًا
        if (!cancelled) setPages(ref.current.querySelectorAll("section.docx").length);
      } catch (e) { if (!cancelled) setErr(e?.message || "تعذّرت المعاينة"); }
      if (!cancelled) setBusy(false);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, deps);
  return (
    <div style={{ background: "#334155", borderRadius: 10, padding: 12, overflow: "auto", maxHeight: height, direction: "ltr" }}>
      {busy && <div style={{ color: "#cbd5e1", textAlign: "center", padding: 20, fontSize: 13 }}>⏳ جارٍ تجهيز المعاينة من ملف Word…</div>}
      {err && <div style={{ color: "#fecaca", textAlign: "center", padding: 16, fontSize: 13 }}>⚠ {err}</div>}
      {!busy && !err && pages > 0 && <div style={{ color: "#e2e8f0", fontSize: 12, textAlign: "center", marginBottom: 8, fontWeight: 700 }}>📄 المعاينة بتنسيق ملف Word نفسه{pages > 1 ? ` — ${pages} صفحات` : ""} (الخطوط حسب المثبّت على جهازك؛ تقسيم الصفحات النهائي في Word/Google Docs)</div>}
      {/* v3.4.558 — جداول العقد من اليمين (bidiVisual لا يدعمه docx-preview) + اتجاه الفقرات */}
      <style>{`.docx-rtl table { direction: rtl !important; } .docx-rtl section.docx { direction: rtl; } .docx-rtl p { unicode-bidi: plaintext; }`}</style>
      <div ref={ref} className="docx-rtl" style={{ transform: zoom !== 1 ? `scale(${zoom})` : undefined, transformOrigin: "top center" }} />
    </div>
  );
}
